import { QuestionsTypes } from '../../actions/questions/questionsTypes'
import { questionsDefaultState } from './defaultState'
import { QandAQuestion } from './types'

function removeDuplicatesAndReplace(existingRes: QandAQuestion[], incomingRes: QandAQuestion[]) {
  return incomingRes.reduce((acc, question) => {
    const existingIndex = existingRes.findIndex(existingQuestion => existingQuestion.id === question.id);
    if (existingIndex !== -1) {
        // If the ID already exists, object with the new one
        acc[existingIndex] = question
    } else {
        // If the ID doesn't exist, new object to the existing array
        acc.push(question)
    }
    return acc
  }, [...existingRes])
}

export default (state = questionsDefaultState, { type, payload }) => {

  switch (type) {

    case QuestionsTypes.SET_QUESTIONS_INITIAL_STATE:
      if ((state.result && payload.result) && payload.result.length < state.result.length) return
      return { ...state,
        conversationClientState: payload.conversationClientState,
        result: payload.result,
        loading: payload.loading }
    case QuestionsTypes.SET_QUESTIONS_MESSAGE_ADDED:
      return { ...state, result: payload.result }
    case QuestionsTypes.SET_NUM_OF_QUESTION_REPLIES_READ:
      return { ...state, result: payload.result }
    case QuestionsTypes.SET_QUESTIONS_UPDATED:
      if (!state.conversationClientState) {
        return { ...state, conversationClientState: payload.conversationClientState, result: payload.result }
      }
      const updatedResult = removeDuplicatesAndReplace(state.result, payload.result)
      return { ...state, result: updatedResult }
    case QuestionsTypes.SET_QUESTIONS_PRIORITY_CHANGED:
      return { ...state, result: payload }
    case QuestionsTypes.SET_QUESTIONS_REQUEST_LOADING:
      return { ...state, loading: payload.loading }
    default: {

      return state

    }

  }

}
